import * as constants from './constants'

export const reducer = (state = {}, action) => {
  const { type, payload } = action

  switch (type) {
    case constants.FIND_TRANSLATION: {
      return {
        error_code: null,
        error_message: null,
        loading: true,
      }
    }
    case constants.FIND_TRANSLATION_SUCCESS: {
      return {
        ...state,
        data: payload.data,
        loading: false,
      }
    }
    case constants.FIND_TRANSLATION_FAILED: {
      return {
        error_code: payload.error_code,
        error_message: payload.error_message,
        loading: false,
      }
    }

    default:
      return state
  }
}
